import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useCloningFlow = () => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading, isSuccess, isError, data, mutate,
  } = useMutation(
    `flow-cloning-${orgId}`,
    ({ cleanRoomId, sourceCrFlowId, ...payload }) => (
      axiosInstance.post(flow(orgId).cloneFlow(cleanRoomId, sourceCrFlowId), payload)
    ),
    {
      onSuccess: () => {
        dispatch(showAlert({ message: 'Flow has been cloned successfuly', type: 'success' }));
      },
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
    },
  );

  return {
    isLoading, isSuccess, isError, data, mutate,
  };
};
